module.exports = __webpack_public_path__ + "static/media/whatsapp.1f3b468b.png";